<template>
  <div class="integral-mall">
    <div class="integral-banner" >
      <template v-if="score !== ''">
        <p>可用积分 Usable integral</p>
        <p>{{ score }}</p>
      </template>
    </div>
    <section class="container" v-show="goodsList.length">
      <TablePage ref="list" @page-change="pageHandler" :total="total" :pageSizeNum="12">
        <div class="good-list-container act-ctn">
          <GoodsPanel
            class="good-item"
            v-for="item in goodsList"
            :coverImage="item.coverImage"
            :spuName="item.spuName"
            :spuNameEn="item.spuNameEn"
            :key="item.id"
            :id="item.id"
            @handleTarget="(id) => handleTarget(id, 0)"
          >
            <template #price>
              <div class="price-content">
                <template v-if="item.intPrice > 0">
                  <span>￥</span>
                  <span>{{ item.integralPrice }}</span>
                </template>
                <span v-if="item.intPrice > 0 && item.integralValue > 0">+</span>
                <template v-if="item.integralValue > 0">
                  <span>{{ item.integralValue }}积分</span>
                </template>
              </div>
            </template>
          </GoodsPanel>
        </div>
      </TablePage>
    </section>
    <div class="empty-content" v-show="!goodsList.length">
      <el-empty :image-size="200"></el-empty>
    </div>
  </div>
</template>

<script>
import GoodsPanel from "@/components/base/GoodsPanel";
import TablePage from "@/components/base/TablePage";
import CountDown from "vue2-countdown";
import moment from "moment";
export default {
  name: "",
  components: { GoodsPanel, CountDown, TablePage },
  data() {
    return {
      goodsList: [], //商品列表
      total: 0,
      score: "",
    };
  },
  props: {},
  computed: {},
  async mounted() {
    this.searchHandler();
    this.getByUid();
  },
  methods: {
    //初始化查询
    searchHandler() {
      this.$refs.list.reset();
    },
    //跳转
    handleTarget(id) {
      this.$router.push(`/e-shop/good-info?id=${id}&type=${4}`);
    },
    async getByUid() {
      let { data } = await this.$api.getByUid();
      this.score = data.score;
    },
    //获取商品列表
    async pageHandler(page, pageSize) {
      const params = {
        sceneIntegralSwitch: 1,
        page: page,
        pageSize: pageSize,
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getGoodsList(params);
        this.goodsList = list.map((item) => {
          item.intPrice = Number(item.integralPrice);
          return item;
        });
        this.total = total;
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.search-content {
  margin-top: 60px;
}
.e-shop-title {
  margin: 159px 0 99px;
}
.act-ctn {
  display: flex;
  flex-wrap: wrap;
}
.good-item {
  margin-right: 30px;
  margin-bottom: 30px;
  width: 380px;
  &.good-item:nth-child(3n) {
    margin-right: 0;
  }
  .desc-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .content-left {
      font-size: 16px;
      font-weight: 400;
      display: flex;
      align-items: center;
    }
    .content-icon {
      width: 21px;
      height: 21px;
      margin-right: 11px;
    }
  }
}
.channel-nav-container {
  margin-bottom: 60px;
  margin-top: 160px;
}
.good-list-container {
  display: flex;
  flex-wrap: wrap;
}
.price-content {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  padding-left: 33px;
  margin-top: 38px;
}
.integral-banner {
  width: 100%;
  height: 300px;
  background: url("~@/assets/img/jfbg.png") 0 0 / 100% 100% no-repeat;
  margin-bottom: 60px;
  padding-top: 100px;
  overflow: hidden;
  box-sizing: border-box;
  p {
    font-size: 30px;

    font-weight: 400;
    color: #ffffff;
    padding-left: 360px;
    &:first-child {
      margin-bottom: 40px;
    }
  }
}
.empty-content {
  min-height: 50vh;
}
</style>
